import { useQuery, useMutation } from '@tanstack/react-query';
import { billingService } from '../services/billing';

export const billingKeys = {
  all: ['billing'] as const,
  list: (userId: string | number) => [...billingKeys.all, 'list', userId] as const,
  detail: (userId: string | number, ledgerNumber: string) => [...billingKeys.all, 'detail', userId, ledgerNumber] as const,
};

export const useBillingList = (userId: string | number | undefined) => {
  return useQuery({
    queryKey: billingKeys.list(userId!),
    queryFn: () => billingService.getBillingList(userId!),
    enabled: !!userId,
  });
};

export const useBillingDetail = (userId: string | number | undefined, ledgerNumber: string | undefined) => {
  return useQuery({
    queryKey: billingKeys.detail(userId!, ledgerNumber!),
    queryFn: () => billingService.getBillingDetail(userId!, ledgerNumber!),
    enabled: !!userId && !!ledgerNumber,
  });
};

export const useDownloadBillingPdf = () => {
  return useMutation({
    mutationFn: ({ userId, ledgerNumber }: { userId: string | number; ledgerNumber: string }) =>
      billingService.downloadPdf(userId, ledgerNumber),
    onSuccess: (blob, variables) => {
      const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `invoice_${variables.ledgerNumber}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
  });
};

export const useExportBillingExcel = () => {
  return useMutation({
    mutationFn: ({ userId, ledgerNumber }: { userId: string | number; ledgerNumber: string }) =>
      billingService.exportExcel(userId, ledgerNumber),
    onSuccess: (blob, variables) => {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `invoice_export_${variables.ledgerNumber}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
  });
};
